/**
 * フォーム入力値のユーティリティ
 */

/**
 * 入力欄が未入力（未編集の undefined / null、または空文字）かを判定する
 *
 * react-hook-form の watch() は未編集の項目で undefined を返すため、
 * 未入力判定は undefined と空文字の両方を見る必要がある。
 */
export const isBlank = (value: string | null | undefined): boolean => !value;
